import { Stack, Typography } from "@mui/material";
import moment from "moment";

import { UnknownTransaction } from "../Type";

type Props = {
	row: UnknownTransaction;
};

export default function TransactionRow({ row }: Props) {
	const hour = row.operationDateHour !== null ? row.operationDateHour + "h" : "";
	const day = moment(row.operationDateDay).format("DD/MM/YYYY");
	return (
		<Stack flexDirection={"row"} alignItems={"center"} gap={3}>
			<Typography textTransform={"capitalize"} variant='subtitle2' width={50}>
				{row.entity}
			</Typography>
			<Typography variant='body2' sx={{ ml: 10 }}>
				{row.description}
			</Typography>
			{row.operationDateDay && (
				<Typography variant='body2' sx={{ ml: 10 }}>
					{`${day} ${hour}`}
				</Typography>
			)}
			{row.amount && (
				<Typography variant='body2' sx={{ ml: 10 }}>
					{row.amount}
				</Typography>
			)}
		</Stack>
	);
}
